import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./company-ui-interactions.actions";

const initialState = {
  interactions: {},
};

export default createReducer(initialState, {
  [actions.setInteractions]: createSetter("interactions"),
  [actions.reset]: () => ({ ...initialState }),
});
